import React from "react"

export default ({ iface, onChange }) => {
  return (
    <div>
      We'd like to put a little interface to edit poses or landmarks here, but
      we need help! Check out this{" "}
      <a href="https://github.com/UniversalDataTool/universal-data-tool/issues/307">
        Github Issue
      </a>{" "}
      to learn more! For now just turn to the JSON tab to edit the landmarks
      manually!
    </div>
  )
}
